module.exports = __webpack_public_path__ + "img/screen-img-02.da43bb6b.webp";